import { BaseError } from './base';

type UserRejectedErrorParams = {
  action: string;
};

export class UserRejectedError extends BaseError {
  constructor({ action }: UserRejectedErrorParams) {
    super({
      cause: null,
      code: 'user_rejected',
      docsUrl: null,
      name: 'UserRejectedError',
      shortMessage: `User rejected action "${action}"`,
    });
  }
}
